import { NewVehicle } from 'src/models';

/**
 * Clear a leftover SPG Model/Option/Engine selection from an earlier no-VIN session.
 * A VIN-identified vehicle never goes through the no-VIN SPG chain, so these fields
 * must not ride along once a VIN resolves the vehicle.
 */
export function clearSpgSelection(vehicle: NewVehicle): void {
    vehicle.spgModel = '';
    vehicle.spgModelId = '';
    vehicle.option = '';
    vehicle.optionId = '';
    vehicle.engine = '';
    vehicle.engineId = '';
}
